/* ═══════════════════════════════════════════
   SMART FOR LIFE — THEME JS
   ═══════════════════════════════════════════ */

(function () {
  'use strict';

  // ── COUNTDOWN TIMER ──
  function initTimer() {
    const hEl = document.getElementById('timerH');
    const mEl = document.getElementById('timerM');
    const sEl = document.getElementById('timerS');
    const stickyEl = document.getElementById('stickyTimerDisplay');

    if (!hEl && !stickyEl) return;

    const hours = window.__timerHours || 4;
    const mins = window.__timerMins || 17;
    let total = hours * 3600 + mins * 60;

    // Persist across page loads in sessionStorage
    const stored = sessionStorage.getItem('sfl_timer_end');
    let endTime;
    if (stored) {
      endTime = parseInt(stored, 10);
    } else {
      endTime = Date.now() + total * 1000;
      sessionStorage.setItem('sfl_timer_end', endTime);
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      const h = Math.floor(remaining / 3600);
      const m = Math.floor((remaining % 3600) / 60);
      const s = remaining % 60;
      const str = pad(h) + ':' + pad(m) + ':' + pad(s);

      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
      if (stickyEl) stickyEl.textContent = str;

      if (remaining <= 0) {
        sessionStorage.removeItem('sfl_timer_end');
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  // ── STICKY ATC BAR ──
  function initStickyATC() {
    const bar = document.getElementById('stickyAtc');
    if (!bar) return;

    // Find hero or first product card to observe
    const heroCard = document.querySelector('.hero-product-card') || document.querySelector('.hero-section');

    if (heroCard) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            bar.classList.add('visible');
          } else {
            bar.classList.remove('visible');
          }
        });
      }, { threshold: 0 });
      observer.observe(heroCard);
    } else {
      // On product pages, show after scrolling 400px
      window.addEventListener('scroll', function () {
        if (window.scrollY > 400) {
          bar.classList.add('visible');
        } else {
          bar.classList.remove('visible');
        }
      }, { passive: true });
    }
  }

  // ── MOBILE MENU ──
  function initMobileMenu() {
    const toggle = document.getElementById('mobileMenuToggle');
    const nav = document.getElementById('mobileNav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', nav.classList.contains('open'));
    });
  }

  // ── CART COUNT UPDATE ──
  function updateCartCount(count) {
    const els = document.querySelectorAll('#cartCount');
    els.forEach(el => { el.textContent = count; });
  }

  // ── AJAX ADD TO CART ──
  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (!form.action || !form.action.includes('/cart/add')) return;

      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.textContent : '';

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(res => res.json())
        .then(data => {
          if (btn) {
            btn.style.background = '#27ae60';
            btn.textContent = '✓ Added to Cart!';
            setTimeout(() => {
              btn.style.background = '';
              btn.textContent = originalText;
            }, 2000);
          }
          // Update cart count
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => updateCartCount(cart.item_count));
        })
        .catch(() => {
          // Fallback: submit normally
          form.submit();
        });
    });
  }

  // ── SCROLL ANIMATIONS ──
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;

    const animEls = document.querySelectorAll('.step, .benefit-card, .review-card, .product-card, .cs-card');

    const observer = new IntersectionObserver(entries => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, i * 60);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    animEls.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

  // ── INIT ──
  document.addEventListener('DOMContentLoaded', function () {
    initTimer();
    initStickyATC();
    initMobileMenu();
    initAjaxCart();
    initScrollAnimations();
  });

})();
